import { ICoords } from "../../redux/modules/flightMarkers/flightMarkersReducer";
import { convertWgs84ToGlobalCoords } from "./convertWgs84ToGlobalCoords";
import { convertGlobalToLocalCoords } from "./convertGlobalToLocalCoords";
import { ISRS } from "../../apiFacades/csu/site";

export const convertWgs84ToLocalCoords = (wgs84Coords: ICoords, srs: ISRS) => {
  const globalCoords = convertWgs84ToGlobalCoords(wgs84Coords, srs);
  return convertGlobalToLocalCoords(globalCoords, srs);
};
